"use strict";

var timeF = require('lmw-time-format');
/**
 * 时间戳格式化
 * @param str
 * @param format
 * @returns {string}
 */
module.exports = function (str, format) {
  if (!str) return "";
  return timeF(parseInt(str), format);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/_ty-vue-filters@1.0.22@ty-vue-filters/dist/filters/timeFormat.js
// module id = G42A
// module chunks = 300